export const legalIdentity = {
  brand: 'NIDO',
  legalName: 'NIDO PORTAL',
  taxId: '27-30078037-2',
  address: null,
  privacyEmail: 'info@nidoportal.com',
  supportPath: '/contacto',
  country: 'República Argentina',
  version: '11 de agosto de 2026',
  isPrototype: false,
};
